import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="panel-visibility"
// sourceのラジオで"true"が選ばれている間だけpanelを表示する(hiddenでも入力値は送信される)
export default class extends Controller {
  static targets = ["source", "panel"]

  connect() {
    this.update()
  }

  update() {
    const visible = this.sourceTargets.some(el => el.checked && el.value === "true")
    this.panelTargets.forEach(el => el.hidden = !visible)
  }
}
